<template>
  <footer class="channel-config__footer">
    <div class="footer__actions">
      <WTooltip
        v-if="showRenameAndCloseButton"
        :label="renameAndCloseTooltip"
        position="top-start"
      >
        <WButton
          variant="cta"
          :disabled="!enableRenameCloseButton"
          :loading="isSaving"
          type="button"
          @click="showRenameCloseModal = true"
        >
          Nomear e encerrar
        </WButton>
      </WTooltip>
      <WButton
        v-if="showRenameButton"
        :disabled="isSaving"
        :loading="isSaving"
        variant="tertiary"
        type="submit"
        @click="$emit('onRenameChannel')"
      >
        Nomear Chat
      </WButton>

      <WButton
        v-else-if="showCreateButton"
        :disabled="isSaving"
        :loading="isSaving"
        @click="$emit('onCreateChannel')"
      >
        Criar Canal
      </WButton>

      <WButton
        v-else-if="showMergeButton"
        :disabled="isSaving"
        :loading="isSaving"
        variant="tertiary"
        @click="$emit('onMergeChannel')"
      >
        Mesclar Canal
      </WButton>
      <WButton
        v-else-if="showArchiveButton"
        variant="cta"
        :disabled="isSaving"
        :loading="isSaving"
        type="button"
        @click="$emit('onArchiveChannel')"
      >
        Encerrar canal
      </WButton>
    </div>
    <WTooltip label="Sair do canal" position="left">
      <WButton
        :disabled="shouldDisableLeaveButton || isSaving"
        :loading="isSaving"
        type="button"
        icon="icLogout"
        variant="secondary"
        icon-button
        size="small"
        data-testid="leave-button"
        @click="leaveChannel"
      />
    </WTooltip>
    <CRenameCloseModal
      v-if="showRenameCloseModal"
      @on-cancel="showRenameCloseModal = false"
      @on-close="renameCloseChat"
    />
    <COwnerModal
      v-if="showOwnerModal"
      :channel-id="controlChannel.id"
      :channel-staff="controlChannel.staff"
      @close="showOwnerModal = false"
      @confirm="$emit('onCloseConfiguration')"
    />
  </footer>
</template>

<script>
import { WButton, WTooltip } from '@alice-health/wonderland-vue'
import { mapState } from 'vuex'

import { CHANNEL_KINDS, CHANNEL_SUBCATEGORIES } from '@/models/channels'

import COwnerModal from './COwnerModal'
import CRenameCloseModal from './CRenameCloseModal'

export default {
  components: {
    COwnerModal,
    WButton,
    CRenameCloseModal,
    WTooltip
  },
  props: {
    showArchiveButton: Boolean,
    isDischarge: Boolean,
    isSaving: Boolean
  },
  emits: [
    'onRenameChannel',
    'onCreateChannel',
    'onMergeChannel',
    'onArchiveChannel',
    'onLeaveChannel',
    'onCloseConfiguration',
    'onDischargeChannel'
  ],
  data() {
    return {
      showOwnerModal: false,
      showRenameCloseModal: false
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('pillars/channel', ['controlChannel', 'mergeChannel']),
    showCreateButton() {
      return !this.controlChannel.id
    },
    showRenameButton() {
      const canRename =
        this.controlChannel.kind === CHANNEL_KINDS.CHAT &&
        this.controlChannel.id &&
        this.controlChannel.name &&
        !this.mergeChannel?.id &&
        this.showRenameButtonVirtualClinic

      return canRename
    },
    showRenameButtonVirtualClinic() {
      return !this.isDigitalPa
    },
    showMergeButton() {
      return !!this.mergeChannel?.id
    },
    shouldDisableLeaveButton() {
      if (this.controlChannel?.staff) {
        return Object.keys(this.controlChannel.staff).length <= 1
      }

      return true
    },
    loggedStaffIsOwner() {
      const staff = this.controlChannel.staff[this.user.id]
      return staff?.owner || false
    },
    showRenameAndCloseButton() {
      return (
        this.controlChannel.kind === CHANNEL_KINDS.CHAT &&
        (this.controlChannel.name || this.showMergeButton)
      )
    },
    isScreeningChannel() {
      return this.controlChannel.subCategory === CHANNEL_SUBCATEGORIES.SCREENING
    },
    isVirtualClinicChannel() {
      return (
        this.controlChannel.subCategory === CHANNEL_SUBCATEGORIES.VIRTUAL_CLINIC
      )
    },
    isDigitalPa() {
      return this.isScreeningChannel || this.isVirtualClinicChannel
    },
    renameAndCloseTooltip() {
      if (this.enableRenameCloseButton) return null
      if (this.showMergeButton) {
        return 'Você só pode nomear e encerrar novos atendimentos'
      }
      if (!this.isDischarge) {
        return 'Você só pode nomear e encerrar quando <br/>a demanda se encaixa em critérios específicos'
      }
      return null
    },
    enableRenameCloseButton() {
      return !this.showMergeButton && (this.isDigitalPa || this.isDischarge)
    }
  },
  methods: {
    renameCloseChat() {
      this.showRenameCloseModal = false
      this.$emit('onDischargeChannel')
    },
    leaveChannel() {
      if (this.loggedStaffIsOwner) {
        this.showOwnerModal = true
      } else {
        this.$emit('onLeaveChannel')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-config__footer {
  display: flex;
  gap: var(--gl-spacing-04);
  justify-content: space-between;

  .footer__actions {
    display: flex;
    justify-content: space-between;
    gap: var(--gl-spacing-06);
  }
}
</style>
